(function () {
  'use strict';

  var page = document.querySelector('.page-combat-wipes');
  if (!page) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var reveals = document.querySelectorAll('.page-combat-wipes .rv');

  if (reduceMotion || !('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(reveals, function (element) {
      element.classList.add('in');
    });
  } else {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    Array.prototype.forEach.call(reveals, function (element) {
      observer.observe(element);
    });
  }

  var nav = document.getElementById('nav');
  if (!nav) return;

  var ticking = false;
  function updateNav() {
    nav.classList.toggle('is-stuck', (window.pageYOffset || 0) > 12);
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateNav);
  }, { passive: true });

  updateNav();
})();
